import cloneDeep from 'lodash/cloneDeep';
export default {
  emailSignatures: state => {
    const signatures = cloneDeep(state.emailSignatures);
    return signatures.map(({ name, ...rest }) => {
      return {
        name: name || 'Default',
        ...rest
      };
    });
  },

  selectedEmailSignature: state => cloneDeep(state.selectedEmailSignature),

  customizedSignatureBusinessProcesses: state => {
    const selectedEmailSignature = state.selectedEmailSignature._id;
    return cloneDeep(
      state.emailSignatures.filter(es => es._id !== selectedEmailSignature && es.assignedEmails.length > 0)
    );
  }
};
